import { useTenantContext } from '../tenant-context/index.tsx';

type AccountId = string;

export const useAccountId = (): AccountId | null => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.atlassianAccountId) || null;
};
